import React, { FC, useState } from 'react';
import { Button } from '@chakra-ui/react';
import { useToggle } from 'react-use';
import { PairToken } from '@app/types/pool';
import { TransactionResultModal } from '@app/components/TransactionResultModal';
import { Vault } from '@app/hooks/plugins/useVaults';
import { Tooltip } from '@app/components/Tooltip';
import { useNitroPool } from '@app/hooks/nitro/useNitroPool';
import { UnstakeFromNitroPoolModal } from '@app/screens/positions/components/SpNftControls/UntakeFromNitroPool/UnstakeFromNitroPoolModal';
import { SiMediafire } from 'react-icons/si';

interface Props {
  tokenDetails: PairToken | Vault;
  tokenId: string;
  deposit: string;
  poolAddress: string;
  onOpen?: (val: boolean) => void;
  showLabel?: boolean;
  nitroPoolId?: string;
}

export const UnstakeFromNitroPool: FC<Props> = ({
  tokenDetails,
  tokenId,
  poolAddress,
  onOpen,
  showLabel,
  nitroPoolId
}) => {
  const [feedback, setFeedback] = useState<{
    status: 'success' | 'error';
    title: string;
    message: string;
    txHash?: string;
  } | null>(null);
  const [open, toggleOpen] = useToggle(false);

  const { data } = useNitroPool(poolAddress, nitroPoolId);

  if (!data) {
    return null;
  }

  return (
    <>
      <Tooltip tooltip="Unstake from Nitro pool">
        <Button
          variant="secondary"
          onClick={e => {
            e.stopPropagation();
            toggleOpen(true);
            onOpen?.(true);
          }}
          _hover={{
            color: 'orange'
          }}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            fontSize: '12px',
            width: '100%',
            gap: 1
          }}
        >
          <SiMediafire size={16} color="var(--chakra-colors-nitro)" />
          {showLabel && 'Unstake from Nitro'}
        </Button>
      </Tooltip>
      <UnstakeFromNitroPoolModal
        isOpen={open}
        onClose={() => {
          toggleOpen(false);
          onOpen?.(false);
        }}
        nitroPoolAddress={data?.id}
        tokenDetails={tokenDetails}
        tokenId={tokenId}
        poolAddress={poolAddress}
        onResult={res => setFeedback(res)}
      />
      <TransactionResultModal
        isOpen={!!feedback}
        status={feedback?.status}
        title={feedback?.title}
        message={feedback?.message}
        txHash={feedback?.txHash}
        onClose={() => {
          setFeedback(null);
          toggleOpen(false);
          onOpen?.(false);
        }}
      />
    </>
  );
};
